import styled from "@emotion/styled";
import { useEffect } from "react";
import * as React from "react";

/**
 * Enhance your component with "copy to clipboard" feature.
 *
 * Two types of usage are supported:
 *
 * 1) provide string to be copied as prop
 *
 * ```
 * <CopyToClipboard value="text to be copied" onCopiedHandler={() => console.log('copied!')}>
 *   {({ handleCopy, isCopied }) => <button onClick={handleCopy}>Click to copy</button>}
 * </CopyToClipboard>
 * ```
 *
 * 2) provide custom input or textarea with content to be copied
 *
 * ```
 * <CopyToClipboard onCopiedHandler={() => console.log('copied!')}>
 *   {({ inputRef, handleCopy, isCopied }) => (
 *     <>
 *       <textarea ref={inputRef}>content to be copied</textarea>
 *       <button onClick={handleCopy}>Click to copy</button>
 *     </>
 *   )}
 * </CopyToClipboard>
 * ```
 */
interface IProps {
  value?: string;
  onCopiedHandler?(): void;
  children(data: {
    handleCopy(): void;
    isCopied: boolean;
    inputRef: React.RefObject<HTMLInputElement>;
  }): React.ReactNode;
}

const StyledInput = styled.textarea`
  z-index: -1;
  width: 0;
  height: 0;
  opacity: 0;
  padding: 0;
  margin: 0;
  display: "none";
`;

export const CopyToClipboard: React.FC<IProps> = ({ value, onCopiedHandler, children }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const inputRef = React.useRef(null);
  const timeout = React.useRef(null);

  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2769): No overload matches this call.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  useEffect(() => () => clearTimeout(timeout.current), []);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCopy = () => {
    // @ts-expect-error TS(2769): No overload matches this call.
    clearTimeout(timeout.current);
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    inputRef.current.select();
    document.execCommand("copy");
    setIsCopied(true);

    // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'null'.
    timeout.current = setTimeout(() => setIsCopied(false), 1500);

    if (onCopiedHandler) {
      onCopiedHandler();
    }
  };

  return (
    <>
      {children({ handleCopy, isCopied, inputRef })}
      {value && <StyledInput ref={inputRef} value={value} readOnly />}
    </>
  );
};
